import { AuditMatch } from '@mi-front/core';
import PlayIcon from '@mui/icons-material/PlayArrow';
import { Button, IconButton, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { usePlayAuditMatch } from '../../hooks/usePlayAuditMatch';

export function PlayButtonP(p: { play: () => void }) {
  const { $t } = useIntl();
  return (
    <Button size="small" sx={{ marginTop: 0.5 }} onClick={p.play}>
      {$t({
        id: 'common.play',
        defaultMessage: 'Reproducir',
      })}
    </Button>
  );
}

export function PlayButton(p: { match: AuditMatch }) {
  const { $t } = useIntl();
  const play = usePlayAuditMatch(p.match);

  return (
    <Tooltip
      title={$t({
        id: 'common.play',
        defaultMessage: 'Reproducir',
      })}
    >
      <IconButton size="small" color="primary" onClick={play}>
        <PlayIcon />
      </IconButton>
    </Tooltip>
  );
}
